import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { FloatingAreaContext } from './context';
/**
 * 플로팅 호스트 타깃과 화면별 `FloatingArea` 포탈을 연결한다.
 * 앱 루트에서 `FloatingAreaHost`와 함께 한 번 마운트한다.
 */
export function FloatingAreaProvider({ children }) {
    const [targets, setTargets] = React.useState({
        persistent: null,
        page: null,
    });
    const setTarget = React.useCallback((region, el) => {
        setTargets((prev) => (prev[region] === el ? prev : { ...prev, [region]: el }));
    }, []);
    const value = React.useMemo(() => ({ targets, setTarget }), [targets, setTarget]);
    return _jsx(FloatingAreaContext.Provider, { value: value, children: children });
}
//# sourceMappingURL=FloatingAreaProvider.js.map